<template>
  <vs-row>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
      <vs-card class="cstm-card">
        <div slot="header">
          <h5>Subject</h5>
          <!-- {{validatorScope}} -->
        </div>
        <br />
        <div class="full_cstm_select_opt_holder" v-click-outside="outsideDropdown">
          <div
            class="selected_opt_holder"
            @click="showDropdown"
            
          >
            <span
              class="placeholderSpan"
              v-if="localValue == '' && !disableOtherLi && !searchOption"
              >Subject Name</span
            >
            <span class="selectedSpan" v-else-if="disableOtherLi">
              General Subject
              <feather-icon icon="XIcon" @click.stop="removeGenSub" />
            </span>
            <span
              class="selectedSpan"
              v-else
              v-for="(eachData, index) in localValue"
              :key="index"
            >
              {{ eachData.subject_name }}
              <feather-icon
                icon="XIcon"
                @click.stop="removeDataOption(index, eachData.id)"
              />
            </span>
            <!-- search input -->
            <input
              type="search"
              v-model="searchOption"
              @keyup="searchSubjectList"
            />
            <feather-icon
              icon="ChevronDownIcon"
              class="downarrow mr-2"
              :class="[show ? 'rotate' : '']"
            />
          </div>
          <div class="dropdown_holder" :class="[show ? 'show' : '']">
            <ul>
              <li>
                <span
                  @click.prevent="addSubjectPopup = !addSubjectPopup"
                  style="color: rgba(var(--vs-primary), 1)"
                  >Add New Subject</span
                >
              </li>
              <li>
                <span @click="genSub">General Subject</span>
              </li>
              <li
                v-for="(option, opt) in subjectlist"
                :key="opt"
                :class="[disableOtherLi ? 'disabled' : '']"
              >
                <span
                  @click="pushTolocalValue(option)"
                  :class="[option.selected ? 'disabled' : '']"
                  >{{ option.subject_name }}</span
                >
              </li>
              <li ref="load" class="loader" v-show="subjectMeta.has_next">
                Loading more subjects...
              </li>
              
            </ul>
          </div>
        </div>
        <!-- <v-select
        multiple
          class="w-full"
          label="subject_name"
          placeholder="Subject Name"
          v-validate="'required'"
          :reduce="(option) => option.id"
          :options="subjectlist"
          v-model="localValue"
          :clearable="true"
          data-vv-name="Subject Name"
          name="Subject Name"
          v-bind:class="{ disabled: subjectDisabled }"
          @open="onOpen"
          @close="onClose"
        >
       
          <template #list-footer>
            <li ref="load" class="loader" v-show="subjectMeta.has_next">
                    Loading more subjects...
                  </li>
            <li style="margin-left: 15px; cursor: pointer">
              <span
                @click.prevent="addSubjectPopup = !addSubjectPopup"
                style="color: rgba(var(--vs-primary), 1); margin-left: 3px"
                >Add New Subject</span
              >
            </li>
          </template>
        </v-select> -->
        <span
          v-show="errors.has('CourseBuilder.Subject Name')"
          class="text-danger block"
          >{{ errors.first("CourseBuilder.Subject Name") }}</span
        >
      </vs-card>
    </vs-col>
    <vs-popup title="Add Subject" :active.sync="addSubjectPopup">
      <form data-vv-scope="addSub">
        <label class="text-sm">Subject Name</label>
        <vs-input
          class="inputx mb-2 w-full"
          v-validate="'required'"
          name="subname"
          v-model="subject_name"
          @keypress="preventKeypress"
        />
        <span v-show="errors.has('addSub.subname')" class="text-danger block">{{
          errors.first("addSub.subname")
        }}</span>
        <label class="text-sm">Subject Description</label>
        <vs-textarea
          class="mb-2 w-full"
          name="subdesc"
          v-model="subject_description"
        />

        <vs-col
          :vs-xs="12"
          :vs-md="12"
          :vs-lg="12"
          class="p-2 centerx"
          vs-type="flex"
          vs-justify="space-between"
        >
          <!-- <div>
            <label for="myfile">Select a file:</label>
            <input
              type="file"
              id="myfile"
              name="myfile"
              @change="uploadImg($event, 1)"
            />
          </div> -->
          <!-- <vs-button color="primary" @click="saveImage">Upload</vs-button> -->
        </vs-col>
        <FileUpload
          section_type="courseHeader"
          :multiplefile="false"
          @getFileIdHeader="getIdFile"
          :file_repository_id="repository_id"
          :filesInfo="filesInfo"
          @deletedIndex="deletedIndex"
          ref="fileUploadRef"
        >
        </FileUpload>
        <vs-divider />
        <vs-button @click="add_subject" class="mt-2" type="filled"
          >Create Subject</vs-button
        >
      </form>
    </vs-popup>
  </vs-row>
</template>

<script>
import vSelect from 'vue-select'
import { Subject } from '@/mixins/subject/subject'

import { list_subject } from '@/api/subject'
import { handleKeypress } from '@/mixins/handleKeypress'
import FileUpload from '@/components/common/FileUpload'
import { repository } from '@/mixins/repository.js'
export default {
  inject: {
    $validator: '$validator'
  },
  name: 'SubjectComponent',
  components: {
    vSelect,
    FileUpload
  },
  mixins: [Subject, handleKeypress, repository],

  props: {
    has_all_subject: {
      type: Boolean
    },
    value: {
      type: Array
    },
    validatorScope: {},
    subjectDisabled: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  created () {
    this.getRepositoryId(35)

    this.fetchSubjectList()
    if (this.has_all_subject) {
      this.genSub()
    }
  },

  data () {
    return {
      allSub:false,
      show:false,
      subjectMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      selectedSubject: [],
      subjectlist: [],
      searchOption: '',
      disableOtherLi: false,
      observer: new IntersectionObserver(this.loadMore)
    }
  },
  watch: {
    show () {
      if (!this.show) {
        this.observer.disconnect()
      }
    },
    selectAllSubjects (newVal) {
      // console.log(newVal, oldVal)
      if (newVal) {
        this.localValue = this.subjectlist.filter((ele) => ele.id !== 0)
      } else {
        this.localValue = null
      }
    },
    localValue () {
      this.localValue.forEach(element => {
        this.subjectlist = this.subjectlist.map(subject => {
          if (subject.id === element.id) {
            subject.selected = true            
          }
          return subject
        })
      })
    },
    allSub () {
      this.localValue = []
      this.$emit('allSub', this.allSub)
    }
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || !el.contains(e.target) && el !== e.target) {
          /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  },
  methods: {
    outsideDropdown () {
      this.show  = false
    },
    pushTolocalValue (option) {
      this.localValue.push(option)
    },
    removeDataOption (index, id) {
      this.localValue.splice(index, 1)
      this.subjectlist = this.subjectlist.map((subject) => {
        if (subject.id === id) {
          subject.selected = false
        }
        return subject
      })
    },
    searchSubjectList () {
      this.searchOption.replace(/ /g, '')
      this.subjectlist = this.subjectlist.filter((ele) => {
        if (
          ele.subject_name.replace(/ /g, '') ===
          this.searchOption.replace(/ /g, '')
        ) {
          return ele
        }
      })
      if (this.searchOption.replace(/ /g, '') === '') {
        this.fetchSubjectList()
      }
    },
    genSub () {
      this.disableOtherLi = true
      this.allSub = true
    },
    removeGenSub () {
      this.disableOtherLi = false
      this.allSub = false
    },
    async showDropdown () {
      this.show = !this.show
      if (this.subjectMeta.has_next) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    async onOpen () {
      if (this.subjectMeta.has_next) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
    },
    async loadMore ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          const response = await list_subject(
            this.$store.getters.customerId,
            this.subjectMeta.current_page + 1
          )
          this.subjectlist.push(...response.data.data.subjectlist)
          this.subjectMeta = response.data.data.meta
        } catch (e) {
          //
        }
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    deletedIndex (deleteIndex) {
      console.log(deleteIndex)
      this.filesInfo.splice(0)
      console.log(this.filesInfo)
      this.file_id = null
      /* this.file_ids.splice(deleteIndex, 1)
      this.filesInfo.splice(deleteIndex, 1) */
    },
    getIdFile (obj) {
      if (Array.isArray(obj)) {
        this.file_id = obj[0]
      } else {
        this.file_id = obj
        console.log(obj)
      }
    },
    async fetchSubjectList () {
      const customerId = this.$store.getters.customerId

      try {
        const { data } = await list_subject(customerId, 1)
        this.subjectlist = data.data.subjectlist
        this.subjectMeta = data.data.meta
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style scoped>
.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  /* background-color: #eef1f6;
      border-color: #d1dbe5;    */
}
</style>